import { useContext, useEffect } from 'react';
import {
  useAccordionButton,
  AccordionContext,
  Button,
} from 'react-bootstrap';

const CustomToggle = ({
  children, eventKey, isValid, variant, handleActiveStep, className,
}) => {
  const { activeEventKey } = useContext(AccordionContext);
  useEffect(() => {
    handleActiveStep(activeEventKey);
  }, [handleActiveStep, activeEventKey]);

  const decoratedOnClick = useAccordionButton(
    eventKey,
  );

  return (
    <Button
      className={className || ''}
      variant={variant}
      size="sm"
      onClick={decoratedOnClick}
      disabled={!isValid}
    >
      {children}
    </Button>
  );
};

export default CustomToggle;
